module.exports = __webpack_public_path__ + "static/img/bg-pt.c1559687.png";